"use strict";var t=require("react").createContext(void 0);exports.IntlContext=t;
